// import React, { useEffect, useRef, useState } from "react";
// import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
// import "./RiskChart.css";
// import del_1 from "../../../../images/del_1.png";
// import edit_1 from "../../../../images/edit_1.png";
// import { FaEdit, FaTrash } from "react-icons/fa";
// import { useLanguage } from "../../../../Providers/LanguageContext";
// import toast from "react-hot-toast";
// import { useDispatch } from "react-redux";
// import {
//   reset_expense_bar_chart,
//   reset_expense_line_chart,
//   reset_expense_per_bar_graph,
//   reset_expense_per_line_graph,
//   reset_kanban_data,
//   reset_open_acc_receive,
//   reset_profit_line_chart,
//   reset_sales_line_chart,
//   set_expense_bar_chart,
//   set_expense_line_chart,
//   set_expense_per_bar_graph,
//   set_expense_per_line_graph,
//   set_open_acc_receive,
//   set_profit_line_chart,
//   set_sales_line_chart,
//   toggle_Kanban_data,
// } from "../../../../redux/reducers/favDashboardSlice";
// import HttpClient from "../../../../utils/HttpClient";
// import DashboardManager from "../../dashboard/DashboardManager";
// import GanttChart from "../../../TaskManager/GanttChart";
// import EventsCalender from "../../../TaskManager/EventsCalender";
// import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
// import RiskManagement from "../../../TaskManager/RiskManagement";

// export default function RiskChart() {
//   const dispatch = useDispatch();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const { language } = useLanguage();

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);
//   const [widgetsThree, setwidgetsThree] = useState([]);

//   // Create a ref for the component
//   const componentRef = useRef(null);

//   const fetchWidgetOneData = async () => {
//     try {
//       const res = await HttpClient.requestData("dashboard", "GET");
//       if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
//         setwidgetsThree(res?.widgets?.eight || []);
//       } else {
//         console.log("error", res);
//         setwidgetsThree([]);
//       }
//     } catch (error) {
//       toast.error(error?.message || "something went wrong!!!");
//     }
//   };

//   useEffect(() => {
//     fetchWidgetOneData();
//   }, []);

//   const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

//   useEffect(() => {
//     if (widgetsThree) {
//       setSelectedWidgetOne(widgetsThree?.find((item) => item?.visible) || null);
//     }
//   }, [widgetsThree]);

//   const handleSelectWidget = (widget) => {
//     setSelectedWidgetOne(widget);
//     toast.success("Widget has been changed successfully");
//     closeModal();
//     // Scroll to component after a short delay to allow state update
//     setTimeout(() => {
//       scrollToComponent();
//     }, 100);
//   };

//   // const handleAddWidget = async (widget) => {
//   //   try {
//   //     const res = await HttpClient.requestData("dashboard", "PUT", {
//   //       widgetId: widget?.widgetId,
//   //     });
//   //     if (res?.message !== "Widget not found in dashboard") {
//   //       toast.success("Widget one has been updated successfully");
//   //       fetchWidgetOneData();
//   //       setSelectedWidgetOne(widget);
//   //       closeModal();
//   //     }
//   //   } catch (error) {
//   //     toast.error(error?.message || "something went wrong!!!");
//   //   }
//   // };

//   useEffect(() => {
//     if (
//       selectedWidgetOne &&
//       selectedWidgetOne?.name === "Kanban Board Analytics"
//     ) {
//       dispatch(toggle_Kanban_data());
//       dispatch(reset_open_acc_receive());
//     }
//     if (
//       selectedWidgetOne &&
//       selectedWidgetOne?.name === "Open Account Receivable"
//     ) {
//       dispatch(reset_kanban_data());
//       dispatch(set_open_acc_receive());
//     }
//     if (
//       selectedWidgetOne &&
//       selectedWidgetOne?.name ===
//         "Expense Percentage vs Profit Percentage Line Graph"
//     ) {
//       dispatch(set_expense_per_line_graph());
//       dispatch(reset_kanban_data());
//       dispatch(reset_open_acc_receive());
//       dispatch(reset_expense_per_bar_graph());
//     }
//     if (
//       selectedWidgetOne &&
//       selectedWidgetOne?.name ===
//         "Expense Percentage vs Profit Percentage Pie Chart"
//     ) {
//       dispatch(set_expense_per_bar_graph());
//       dispatch(reset_kanban_data());
//       dispatch(reset_open_acc_receive());
//       dispatch(reset_expense_per_line_graph());
//     }
//     if (selectedWidgetOne && selectedWidgetOne?.name === "Expense Bar Chart") {
//       dispatch(set_expense_bar_chart());
//       dispatch(reset_kanban_data());
//       dispatch(reset_open_acc_receive());
//       dispatch(reset_expense_per_line_graph());
//       dispatch(reset_expense_per_bar_graph());
//       dispatch(reset_profit_line_chart());
//       dispatch(reset_sales_line_chart());
//       dispatch(reset_expense_line_chart());
//     }
//     if (selectedWidgetOne && selectedWidgetOne?.name === "Expense Line Chart") {
//       dispatch(set_expense_line_chart());
//       dispatch(reset_kanban_data());
//       dispatch(reset_open_acc_receive());
//       dispatch(reset_expense_per_line_graph());
//       dispatch(reset_expense_per_bar_graph());
//       dispatch(reset_profit_line_chart());
//       dispatch(reset_sales_line_chart());
//       dispatch(reset_expense_bar_chart());
//     }
//     if (selectedWidgetOne && selectedWidgetOne?.name === "Profit Line Chart") {
//       dispatch(set_profit_line_chart());
//       dispatch(reset_kanban_data());
//       dispatch(reset_open_acc_receive());
//       dispatch(reset_expense_per_line_graph());
//       dispatch(reset_expense_per_bar_graph());
//       dispatch(reset_profit_line_chart());
//       dispatch(reset_sales_line_chart());
//       dispatch(reset_expense_bar_chart());
//       dispatch(reset_expense_line_chart());
//     }
//     if (selectedWidgetOne && selectedWidgetOne?.name === "Sales Line Chart") {
//       dispatch(set_sales_line_chart());
//       dispatch(reset_kanban_data());
//       dispatch(reset_open_acc_receive());
//       dispatch(reset_expense_per_line_graph());
//       dispatch(reset_expense_per_bar_graph());
//       dispatch(reset_profit_line_chart());
//       dispatch(reset_sales_line_chart());
//       dispatch(reset_expense_bar_chart());
//       dispatch(reset_expense_line_chart());
//       dispatch(reset_profit_line_chart());
//     }
//   }, [dispatch, selectedWidgetOne]);

//   // Function to smoothly scroll to component
//   const scrollToComponent = () => {
//     if (componentRef.current) {
//       const element = componentRef.current;
//       const elementPosition =
//         element.getBoundingClientRect().top + window.pageYOffset;
//       const offsetPosition = elementPosition - 100; // 100px offset from top

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth",
//       });
//     }
//   };

//   const handleAddWidget = async (widget) => {
//     try {
//       const res = await HttpClient.requestData("dashboard", "PUT", {
//         widgetId: widget?.widgetId,
//       });
//       if (res?.message !== "Widget not found in dashboard") {
//         toast.success("Widget one has been updated successfully");
//         fetchWidgetOneData();
//         setIsModalOpen(false);
//         // Scroll to component after a short delay to allow state update
//         setTimeout(() => {
//           scrollToComponent();
//         }, 100);
//       }
//     } catch (error) {
//       toast.error(error?.message || "something went wrong!!!");
//     }
//   };

//   const data = [
//     { name: "Marketing", value: 62 },
//     { name: "Customer Service", value: 38 },
//   ];

//   const COLORS = ["#092332", "#B4B4B4"];

//   return (
//     <>
//       <div
//         className="risk-chart-card chart-div-style"
//         style={{ width: "100%" }}
//         ref={componentRef}
//       >
//         {/* HEADER - Updated with modal functionality */}
//         <div className="risk-chart-header">
//           <h3 className="risk-chart-title">
//             {selectedWidgetOne?.name || "Risk by business unit"}
//           </h3>
//           <div className="icons-dc">
//             {/* EDIT ICON – opens modal */}
//             <i
//               className="fa-regular fa-pen-to-square icon-dc"
//               onClick={openModal}
//             ></i>
//             {/* <i className="fa-solid fa-trash icon-dc"></i> */}
//           </div>
//         </div>

//         {/* Conditionally render the original RiskChart content only for Risk by business unit */}

//         {/* Render other widgets based on selection */}
//         {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
//         {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
//         {selectedWidgetOne?.name === "Investment Manager" && (
//           <ViewCapitalOption />
//         )}
//         {selectedWidgetOne?.name === "Kanban Board Analytics" && (
//           <EventsCalender />
//         )}
//         {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
//         {selectedWidgetOne?.name === "Open Account Receivable" && (
//           <DashboardManager />
//         )}
//         {selectedWidgetOne?.name ===
//           "Expense Percentage vs Profit Percentage Line Graph" && (
//           <DashboardManager />
//         )}
//         {selectedWidgetOne?.name ===
//           "Expense Percentage vs Profit Percentage Pie Chart" && (
//           <DashboardManager />
//         )}
//         {selectedWidgetOne?.name === "Expense Bar Chart" && (
//           <DashboardManager />
//         )}
//         {selectedWidgetOne?.name === "Expense Line Chart" && (
//           <DashboardManager />
//         )}
//         {selectedWidgetOne?.name === "Profit Line Chart" && (
//           <DashboardManager />
//         )}
//         {selectedWidgetOne?.name === "Sales Line Chart" && <DashboardManager />}
//       </div>

//       {/* MODAL */}
//       {isModalOpen && (
//         <div className="gd-modal-overlay" onClick={closeModal}>
//           <div
//             className="gd-modal-panel chart-div-style"
//             onClick={(e) => e.stopPropagation()} // prevent overlay close
//           >
//             <h3 className="gd-modal-title">{language?.add_new_dashboard}</h3>

//             <div className="gd-modal-list d-none">
//               <button className="gd-modal-row">
//                 <span>Kanban Board Analytics</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>Gantt Chart</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>Risk Management</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>Progress Chart</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>Forecasting</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>View all balance</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>Event calender</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>

//               <button className="gd-modal-row">
//                 <span>Investment Manager</span>
//                 <span className="gd-modal-plus-btn">
//                   <i className="fa-solid fa-plus"></i>
//                 </span>
//               </button>
//             </div>

//             <div className="gd-modal-list">
//               {widgetsThree?.length > 0 ? (
//                 widgetsThree?.map((widget) => (
//                   <button
//                     disabled={widget?.visible}
//                     className="gd-modal-row"
//                     key={widget?.id}
//                     // onClick={() => handleSelectWidget(widget)}
//                     onClick={() => handleAddWidget(widget)}
//                     style={{
//                       opacity: widget?.visible ? 0.3 : 1,
//                       cursor: widget?.visible ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <span>{widget?.name}</span>
//                     <span
//                       style={{
//                         opacity: widget?.visible ? 0.3 : 1,
//                         cursor: widget?.visible ? "not-allowed" : "pointer",
//                       }}
//                       className="gd-modal-plus-btn"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleAddWidget(widget);
//                       }}
//                     >
//                       <i className="fa-solid fa-plus"></i>
//                     </span>
//                   </button>
//                 ))
//               ) : (
//                 <div className="gd-modal-row">
//                   <span>No Widget Found ...</span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// ----------------------------------------------------------------------------------------------------------------------------------

import React, { useEffect, useRef, useState } from "react";
// import edit_1 from "../../../images/edit_1.png";
// import del_1 from "../../../images/del_1.png";
// import FBChart1 from "./FBchart1";
// import { useLanguage } from "../../../Providers/LanguageContext";
// import GanttChart from "../../TaskManager/GanttChart";
// import EventsCalender from "../../TaskManager/EventsCalender";
import toast from "react-hot-toast";
// import ViewCapitalOption from "../../InvestmentManager/UserInvestor/ViewCapitalOption";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard8,
  reset_current_total_bar8,
  // reset_current_total_bar8,
  reset_current_total_line8,
  reset_current_vs_actual_budget_bar8,
  reset_current_vs_actual_budget_line8,
  reset_expense_bar_chart8,
  reset_expense_line_chart8,
  reset_expense_per_bar_graph8,
  reset_expense_per_line_graph8,
  reset_kanban_data8,
  reset_open_acc_receive8,
  reset_profit_line_chart8,
  reset_sales_line_chart8,
  reset_task_at_risk8,
  reset_task_complete_status8,
  reset_task_deviation_analysis8,
  reset_tax_line8,
  reset_tax_pie8,
  reset_transaction_dashboard8,
  set_balance_dashboard8,
  set_current_total_bar8,
  set_current_total_line8,
  set_current_vs_actual_budget_bar8,
  set_current_vs_actual_budget_line8,
  set_expense_bar_chart8,
  set_expense_line_chart8,
  set_expense_per_bar_graph8,
  set_expense_per_line_graph8,
  set_open_acc_receive8,
  set_profit_line_chart8,
  set_sales_line_chart8,
  set_task_at_risk8,
  set_task_complete_status8,
  set_task_deviation_analysis8,
  set_tax_line8,
  set_tax_pie8,
  set_transaction_dashboard8,
  toggle_Kanban_data8,
} from "../../../../redux/reducers/favDashboardSlice";
// import RiskManagement from "../../TaskManager/RiskManagement";
// import DashboardManager from "../dashboard/DashboardManager";
// import HttpClient from "../../../utils/HttpClient";
// import { useUserData } from "../../../Providers/UserWrapper";
// import Loader from "../../../Loader/Loader";
import { useSelector } from "react-redux";
import { useLanguage } from "../../../../Providers/LanguageContext";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import RiskManagement from "../../../TaskManager/RiskManagement";
import DashboardManager from "../../dashboard/DashboardManager";
import HttpClient from "../../../../utils/HttpClient";
import { useUserData } from "../../../../Providers/UserWrapper";
import Loader from "../../../../Loader/Loader";
import DashboardManager8 from "../../dashboard/DashboardManager8";
// import { toggle_Kanban_data } from "../../../../redux/reducers/favDashboardSlice";

const GrandChart = () => {
  const { taskCompletionStatus, taskAtRisk, taskDeviationAnalysis } =
    useSelector((state) => state?.favDashboard);
  const { setIsLoading } = useUserData();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language } = useLanguage();
  const componentRef = useRef(null);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [widgetsOne, setWidgetsOne] = useState([]);

  const fetchWidgetOneData = async () => {
    try {
      setIsLoading(true);
      const res = await HttpClient.requestData("dashboard", "GET");
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        // console.log("fav init res: ", res);
        setWidgetsOne(res?.widgets?.eight || []);
      } else {
        console.log("error", res);
        setWidgetsOne([]);
        //   toast.error("widget one data is not able to load ....");
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

  useEffect(() => {
    if (widgetsOne) {
      setSelectedWidgetOne(widgetsOne?.find((item) => item?.visible) || null);
    }
  }, [widgetsOne]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
  };

  // useEffect(() => {
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Kanban Board Analytics") {
  //         dispatch(toggle_Kanban_data());
  //         dispatch(reset_open_acc_receive());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Open Account Receivable") {
  //         dispatch(reset_kanban_data());
  //         dispatch(set_open_acc_receive());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "profit vs expense (line graph)") {
  //         dispatch(set_expense_per_line_graph());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_bar_graph());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "profit vs expense (pie graph)") {
  //         dispatch(set_expense_per_bar_graph());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Expense Bar Chart") {
  //         dispatch(set_expense_bar_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_profit_line_chart());
  //         dispatch(reset_sales_line_chart());
  //         dispatch(reset_expense_line_chart());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Expense Line Chart") {
  //         dispatch(set_expense_line_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_profit_line_chart());
  //         dispatch(reset_sales_line_chart());
  //         dispatch(reset_expense_bar_chart());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Profit Line Chart") {
  //         dispatch(set_profit_line_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_sales_line_chart());
  //         dispatch(reset_expense_bar_chart());
  //         dispatch(reset_expense_line_chart());
  //     }
  //     if (selectedWidgetOne && selectedWidgetOne?.name === "Sales Line Chart") {
  //         dispatch(set_sales_line_chart());
  //         dispatch(reset_kanban_data());
  //         dispatch(reset_open_acc_receive());
  //         dispatch(reset_expense_per_line_graph());
  //         dispatch(reset_expense_per_bar_graph());
  //         dispatch(reset_profit_line_chart());
  //         dispatch(reset_expense_bar_chart());
  //         dispatch(reset_expense_line_chart());
  //         dispatch(reset_profit_line_chart());
  //     }

  // }, [dispatch, selectedWidgetOne]);

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data8());
      dispatch(reset_open_acc_receive8());
      dispatch(reset_expense_per_line_graph8());
      dispatch(reset_expense_per_bar_graph8());
      dispatch(reset_expense_bar_chart8());
      dispatch(reset_expense_line_chart8());
      dispatch(reset_profit_line_chart8());
      dispatch(reset_sales_line_chart8());
      dispatch(reset_task_complete_status8());
      dispatch(reset_task_deviation_analysis8());
      dispatch(reset_task_at_risk8());
      dispatch(reset_current_total_bar8());
      dispatch(reset_current_total_line8());
      dispatch(reset_current_vs_actual_budget_bar8());
      dispatch(reset_current_vs_actual_budget_line8());
      dispatch(reset_transaction_dashboard8());
      dispatch(reset_balance_dashboard8());
      dispatch(reset_tax_line8());
      dispatch(reset_tax_pie8());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data8());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive8());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph8());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph8());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart8());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart8());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart8());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart8());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status8());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis8());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk8());
          break;

        case "current total (bar graph)":
          dispatch(set_current_total_bar8());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line8());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar8());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line8());
          break;
        case "Balance dashboard":
          dispatch(set_balance_dashboard8());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard8());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie8());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line8());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const handleAddWidget = async (widget) => {
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        fetchWidgetOneData();
        setSelectedWidgetOne(widget);
        closeModal();
        setTimeout(() => {
          scrollToComponent();
        }, 100);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };
  const scrollToComponent = () => {
    if (componentRef.current) {
      const element = componentRef.current;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  console.log("selectedWidgetOne: ", selectedWidgetOne);

  return (
    <>
      <div className="grand-chart-div chart-div-style" ref={componentRef}>
        {!selectedWidgetOne && <Loader />}
        <div className="calendar-wrapper-mc">
          <div className="calendar-header-mc">
            <h3 class="chart-title-mc">{selectedWidgetOne?.name?.toUpperCase() ||
              "Average Risk"?.toUpperCase()}</h3>
            <i
              className="fa-regular fa-pen-to-square edit-icon-mc"
              onClick={openModal}
            ></i>
          </div>
        </div>
        {/* <div className="grand-chart-head">
          <div className="chart-head-left">
            <h3 className="grantt-title">
              {selectedWidgetOne?.name?.toUpperCase()}
            </h3>
          </div>

          <div className="chart-head-right">
            <div className="head-right-1 d-none">
              <button className="f-btn">New Features</button>
              <button className="f-btn">Select User</button>
            </div>

            <div className="icons-dc">
              <i
                className="fa-regular fa-pen-to-square icon-dc"
                onClick={openModal}
              ></i>
            </div>
          </div>
        </div> */}

        <div className="sinter-matchine-row d-none">
          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 1</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Replacing thermometer - <span>#221455</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 2</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 3</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 4</span>
            </p>
          </div>

          <div className="sinter-matchine-card">
            <div className="sinter-matchine-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <p className="sinter-matchine-title">
              Sinter machine complex - <span>#Task 5</span>
            </p>
          </div>
        </div>

        {/* <FBChart1 /> */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager8 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement
            taskCompleteStatus={taskCompletionStatus}
            taskAtRisk={taskAtRisk}
            taskDeviationAnalysis={taskDeviationAnalysis}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement
            taskCompleteStatus={taskCompletionStatus}
            taskAtRisk={taskAtRisk}
            taskDeviationAnalysis={taskDeviationAnalysis}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement
            taskCompleteStatus={taskCompletionStatus}
            taskAtRisk={taskAtRisk}
            taskDeviationAnalysis={taskDeviationAnalysis}
          />
        )}
        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager8 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager8 />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()} // prevent overlay close
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase()}
            </h3>

            <div className="gd-modal-list d-none">
              <button className="gd-modal-row">
                <span>Kanban Board Analytics</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Gantt Chart</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Risk Management</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Progress Chart</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Forecasting</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>View all balance</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Event calender</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>

              <button className="gd-modal-row">
                <span>Investment Manager</span>
                <span className="gd-modal-plus-btn">
                  <i className="fa-solid fa-plus"></i>
                </span>
              </button>
            </div>

            <div className="gd-modal-list">
              {widgetsOne?.length > 0 ? (
                widgetsOne?.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GrandChart;
